module.exports = __webpack_public_path__ + "media/images/favicon/master-ffc8ba49a3d342dae9ea03298103bf14.png";